import type { BotInstance } from "../../api/types";
import type { ControlTarget } from "../../api/types";

interface BotInstanceSelectorProps {
  instances: BotInstance[];
  value: ControlTarget;
  onChange: (v: ControlTarget) => void;
}

/**
 * The ONE selector in the whole app that addresses a specific
 * bot_instance_id instead of the merged multi-bot view — required on
 * /control because kill-switch and panic-close touch real trading capital
 * per-instance. Every other page (Обзор/Сделки/Логи) intentionally has no
 * equivalent of this.
 */
export function BotInstanceSelector({ instances, value, onChange }: BotInstanceSelectorProps) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <label style={{ font: "600 12.5px 'Golos Text',sans-serif", color: "var(--fg2)" }}>Цель действия</label>
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: 9,
            padding: "9px 12px",
            border: "1px solid var(--line)",
            borderRadius: 10,
            background: value === "all" ? "var(--accentsoft)" : "transparent",
            cursor: "pointer",
            font: "500 13px 'Golos Text',sans-serif",
          }}
        >
          <input type="radio" name="control-target" checked={value === "all"} onChange={() => onChange("all")} />
          Все инстансы
        </label>
        {instances.map((inst) => (
          <label
            key={inst.bot_instance_id}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 9,
              padding: "9px 12px",
              border: "1px solid var(--line)",
              borderRadius: 10,
              background: value === inst.bot_instance_id ? "var(--accentsoft)" : "transparent",
              cursor: "pointer",
              font: "500 13px 'Golos Text',sans-serif",
            }}
          >
            <input
              type="radio"
              name="control-target"
              checked={value === inst.bot_instance_id}
              onChange={() => onChange(inst.bot_instance_id)}
            />
            <span style={{ flex: 1 }}>{inst.display_name}</span>
            <span style={{ font: "400 11px 'JetBrains Mono',monospace", color: "var(--fg3)" }}>{inst.bot_instance_id}</span>
            {inst.trading_disabled && (
              <span
                style={{
                  font: "600 10px 'Golos Text',sans-serif",
                  letterSpacing: ".04em",
                  padding: "2px 6px",
                  borderRadius: 5,
                  background: "var(--warnsoft)",
                  color: "var(--warn)",
                }}
              >
                ВЫКЛ
              </span>
            )}
          </label>
        ))}
      </div>
    </div>
  );
}
